export const panel = "bg-[#111113] border border-zinc-800";
export const inputCls = "w-full bg-zinc-950 border border-zinc-800 px-3 py-2.5 text-sm text-zinc-100 focus:border-accent-ss placeholder:text-zinc-600";
export const btnPrimary = "btn-accent px-4 py-2.5 text-xs font-bold uppercase tracking-wider";
export const btnGhost = "border border-zinc-700 px-4 py-2.5 text-xs font-bold uppercase tracking-wider text-zinc-200 hover:border-zinc-500";

export function Field({ label, children, hint }) {
  return (
    <label className="block">
      <span className="text-[11px] uppercase tracking-widest text-zinc-400 font-semibold">{label}</span>
      <div className="mt-1.5">{children}</div>
      {hint && <span className="text-[11px] text-zinc-600 mt-1 block">{hint}</span>}
    </label>
  );
}

export function PageHead({ title, children }) {
  return (
    <div className="flex items-center justify-between flex-wrap gap-3 mb-6">
      <h1 className="font-display text-3xl sm:text-4xl text-white uppercase tracking-wide">{title}</h1>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}
